var version = {
    "name":      "dativery",
    "buildDateCode": "20260422-100010",
    "buildDate": "Wed Apr 22 2026 10:00:10 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260422-100010",
    "backupUIVersion": "2.2.0-20250522-134816"
}
;
 export default version;